module.exports = __webpack_public_path__ + "img/aurora-desktop.e708daf3.webp";